var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none",
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#11004C",
    fillRule: "evenodd",
    d: "M6.923 1.543a2.311 2.311 0 00-2.308 2.314 2.311 2.311 0 002.308 2.314 2.311 2.311 0 002.308-2.314 2.311 2.311 0 00-2.308-2.314zM3.077 3.857A3.852 3.852 0 016.923 0a3.852 3.852 0 013.846 3.857 3.852 3.852 0 01-3.846 3.857 3.852 3.852 0 01-3.846-3.857z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#11004C",
    fillRule: "evenodd",
    d: "M0 3.857a.77.77 0 01.77-.771h3.076a.77.77 0 010 1.543H.77A.77.77 0 010 3.857zM9.23 3.857a.77.77 0 01.77-.771h9.23a.77.77 0 010 1.543H10a.77.77 0 01-.77-.772zM13.077 11.829a2.31 2.31 0 012.307 2.314 2.311 2.311 0 01-2.307 2.314 2.311 2.311 0 01-2.308-2.314 2.31 2.31 0 012.308-2.315zm3.846 2.314a3.852 3.852 0 00-3.846-3.857 3.852 3.852 0 00-3.846 3.857A3.852 3.852 0 0013.077 18a3.852 3.852 0 003.846-3.857z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#11004C",
    fillRule: "evenodd",
    d: "M20 14.143a.77.77 0 00-.77-.772h-3.076a.77.77 0 000 1.543h3.077a.77.77 0 00.769-.771zM10.77 14.143a.77.77 0 00-.77-.771H.77a.77.77 0 000 1.542H10a.77.77 0 00.77-.771z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.ce20bf8a66f67d1000538a8a7a264cba.svg";
export { ForwardRef as ReactComponent };